import React, { createContext, useState, useEffect, useContext } from 'react';
import { translations } from '../data/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within LanguageProvider');
    }
    return context;
};

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState('en');
    const [direction, setDirection] = useState('ltr');

    useEffect(() => {
        const savedLang = localStorage.getItem('language') || 'en';
        updateLanguageState(savedLang);
    }, []);

    const updateLanguageState = (lang) => {
        setLanguage(lang);
        localStorage.setItem('language', lang);

        const newDir = (lang === 'ar' || lang === 'ku') ? 'rtl' : 'ltr';
        setDirection(newDir);

        document.documentElement.dir = newDir;
        document.documentElement.lang = lang;

        // Simple state change for body class could also be used for CSS overrides
        document.body.className = `lang-${lang} dir-${newDir}`;
    };

    const changeLanguage = (lang) => {
        updateLanguageState(lang);
    };

    // Translation helper function
    const t = (path) => {
        const keys = path.split('.');
        let result = translations[language];

        for (const key of keys) {
            if (result && result[key]) {
                result = result[key];
            } else {
                return path; // Fallback to path string if not found
            }
        }
        return result;
    };

    const value = {
        language,
        direction,
        changeLanguage,
        t
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export default LanguageContext;
